import React, { FunctionComponent } from "react";
import styles from "./Cards.module.scss";
import CardsProps from "./CardsProps.interface";

import Card from "./components/Card/Card";
import Carousel from "./components/Carousel/Carousel";

import { useDispatch } from "react-redux";
import Button from "components/Button/Button";
import combineClasses from "helpers/combine-classes";
import DynamicHeading from "components/DynamicHeading/DynamicHeading";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import handleOpenModal from "blocks/helpers/handleOpenModal";
import Paragraph from "components/Paragraph/Paragraph";
import useAnchorIdentifier from "hooks/useAnchorIdentifier";

const Cards: FunctionComponent<CardsProps> = (props) => {
    const dispatch = useDispatch();

    const wrapperClasses = getWrapperClasses(props.settings);
    const identifier = useAnchorIdentifier(props.settings.anchorIdentifier);

    return (
        <section className={combineClasses([styles.wrapper, ...wrapperClasses])} id={identifier}>
            <div className={styles.header}>
                <div className={styles.header_inner}>
                    <div className={styles.header_content}>
                        {/* Headline */}
                        {props.content.headline ? (
                            <DynamicHeading headlineSize={props.settings.headlineSize} headlineWeight={props.settings.headlineWeight}>{props.content.headline}</DynamicHeading>
                        ) : null}

                        {/* Text */}
                        {props.content.bodyText ? (
                            <Paragraph innerHTML={props.content.bodyText} />
                        ) : null}
                    </div>

                    {/* Buttons */}
                    {props.content.buttons && props.content.buttons.length > 0 ? (
                        <div className={styles.buttons}>
                            {props.content.buttons.map((button, index) => {
                                return (
                                    <Button key={button.contentUdi} className={styles.button} modal={button.content.modal} onClick={() => { button.content.modal ? handleOpenModal(button.content.modal, button.content.stickyLink, dispatch) : undefined; }} to={button.content.link} parameters={button.content.parameters} anchor={button.content.anchor} settings={button.settings}>{button.content.label}</Button>
                                );
                            })}
                        </div>
                    ) : null}
                </div>
            </div>

            {/* Cards */}
            {props.content.cards && props.content.cards.length > 0 ? (
                <Carousel>
                    {props.content.cards.map((item, index) => {
                        return (
                            <Card key={index} {...item} imageCrop={props.settings.imageCrop} />
                        );
                    })}
                </Carousel>
            ) : null}
        </section>
    );
};

export default Cards;